import React, { Fragment } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isNil, includes } from 'ramda';
import { Box, Typography } from '@material-ui/core';

import MortgageSurveyPresenter, { PURPOSE_TYPES } from 'presenters/MortgageSurveyPresenter';
import MortgageSurvey from 'sharedComponents/MortgageSurvey';
import MortgageSurveyFlowSelect from 'sharedComponents/MortgageSurveyFlowSelect';
import * as surveyQuestions from 'lib/surveys';

import useStyles from './useStyles';

const Survey = props => {
  const { onSelectFlow, selectedFlow, surveyValues, setInitialSurveyValues, hasBidRequest } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const handleSelectFlow = value => {
    const initialValues = MortgageSurveyPresenter.buildInitialSurveyFlowValues(surveyValues, value);
    setInitialSurveyValues(initialValues);
    onSelectFlow(value);
  };

  const isNeedToSelectFlow = isNil(selectedFlow);

  if (isNeedToSelectFlow) {
    return (
      <Box className={classes.container}>
        <MortgageSurveyFlowSelect
          onSelect={handleSelectFlow}
          rowComponent={
            <Fragment>
              <Typography variant="h1" className={classes.header}>
                {t('components.SurveyPage.Survey.header')}
              </Typography>
              <Box mt={2} />
              <Typography variant="body1" className={classes.description}>
                {t('components.SurveyPage.Survey.description')}
              </Typography>
              <Box mt={2} />
            </Fragment>
          }
        />
      </Box>
    );
  }

  const { questions } = includes(selectedFlow, PURPOSE_TYPES.refinance)
    ? surveyQuestions.refinanceSurvey
    : surveyQuestions.purchaseSurvey;

  return <MortgageSurvey initialValues={surveyValues} initialPassing={!hasBidRequest} questions={questions} />;
};

Survey.propTypes = {
  onSelectFlow: PropTypes.func.isRequired,
  selectedFlow: PropTypes.string,
  surveyValues: MortgageSurveyPresenter.shape().isRequired,
  setInitialSurveyValues: PropTypes.func.isRequired,
  hasBidRequest: PropTypes.bool.isRequired,
};

Survey.defaultProps = {
  selectedFlow: null,
};

export default Survey;



// WEBPACK FOOTER //
// ./src/components/SurveyPage/components/Survey/Survey.js